import { render } from "./MapaLotes.vue?vue&type=template&id=70de2269"
import script from "./MapaLotes.vue?vue&type=script&lang=js"
export * from "./MapaLotes.vue?vue&type=script&lang=js"

import "./MapaLotes.vue?vue&type=style&index=0&id=70de2269&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__